import "./LocalSeoConsultantDerby.module.css";
import Header from "@/reusable_sections/Header";
import Positioning from "./sections/Positioning";
import Services from "./sections/Services";
import Localseoservices from "./sections/Localseoservices";
import LocalHero from "./sections/LocalHero";
import Consultant from "./sections/Consultant";
import Localseofaq from "./sections/Localseofaq";
import Consultation from "./sections/Consultation";
import Impact from "./sections/Impact";
import Methodology from "./sections/Methodology";
import Localsearchtrends from "./sections/Localsearchtrends";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantDerbyPage() {
  return <div>
      <Header />
      <Positioning />
      <Services />
      <Localseoservices />
      <LocalHero />
      <Consultant />
      <Localseofaq />
      <Consultation />
      <Impact />
      <Methodology />
      <Localsearchtrends />
      <Footer />
    </div>;
}